module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/patient-profile/patient-profile.component.css
// module id = ./src/app/registration/patient-profile/patient-profile.component.css
// module chunks = main